import { FirebaseRemoteConfig } from "@capacitor-firebase/remote-config";
import { Capacitor } from "@capacitor/core";
import { getDeployEnv } from "../environment.js";

// Lazy: must not be evaluated at module load (runs before bootstrap completes
// runtime-config load). Callers are React components or async functions —
// reading here is safe.
export function isCapacitorEnabled(): boolean {
  return getDeployEnv() !== "local" && Capacitor.isNativePlatform();
}

let firebaseActivatePromise: Promise<void> | null = null;

function ensureFirebaseActivated(): Promise<void> | null {
  if (!isCapacitorEnabled()) return null;
  if (!firebaseActivatePromise) {
    firebaseActivatePromise = FirebaseRemoteConfig.fetchAndActivate().then(
      () => undefined
    );
  }
  return firebaseActivatePromise;
}

export async function getCapacitorAppUrl() {
  const promise = ensureFirebaseActivated();
  if (promise) {
    await promise;
    const { value } = await FirebaseRemoteConfig.getString({
      key: "capacitorAppUrl",
    });
    console.log(`[Remote Config / App URL]: ${value}`);
    if (value) return value;
  }
}

export async function getIOSAppBuildNumber() {
  const promise = ensureFirebaseActivated();
  if (promise) {
    await promise;
    const { value } = await FirebaseRemoteConfig.getNumber({
      key: "iosAppBuildNumber",
    });
    console.log(`[Remote Config / iOS Build number]: ${value}`);
    if (value !== null && value !== undefined) return value;
  }
}

export async function getAndroidAppBuildNumber() {
  const promise = ensureFirebaseActivated();
  if (promise) {
    await promise;
    const { value } = await FirebaseRemoteConfig.getNumber({
      key: "androidAppBuildNumber",
    });
    console.log(`[Remote Config / Android Build number]: ${value}`);
    if (value !== null && value !== undefined) return value;
  }
}
